import { render, staticRenderFns } from "./AdditionalServicesInternational.vue?vue&type=template&id=998b7ce2&scoped=true&"
import script from "./AdditionalServicesInternational.vue?vue&type=script&lang=js&"
export * from "./AdditionalServicesInternational.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998b7ce2",
  null
  
)

export default component.exports